import React, { useState } from "react";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Text } from "../../Base";
import { View } from "../../View";
import { memo } from "react";
import { WarningIcon } from "../../Icons/Warning";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "2px",
    cursor: "pointer",
  },
  container: {
    maxWidth: "86px",
    minWidth: "30px",
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    padding: "2px",
  },
  textContainer: {
    background: palette.black,
    borderRadius: "4px",
  },
  text: {
    margin: "auto",
  },
  conflictIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: palette.dpdRed,
    borderRadius: "4px",
  },
  conflictIcon: {
    width: "18px",
    height: "18px",
    fill: palette.typography.white.high,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  spacing: {
    padding: "2px",
  },
  icon: {
    height: "10px",
    width: "10px",
  },
  overrideCountContainer: {
    height: "16px",
    width: "16px",
    borderRadius: "100px",
    background: palette.white,
    position: "relative",
    right: "8px",
    top: "8px",
  },
  overrideCountText: {
    fontSize: "10px",
    margin: "auto",
  },
});

export const OverrideMarkerLabel = memo(
  ({
    routes,
    selectedRoute,
    overrides,
    coordinates,
    handleOverrideModalChange,
  }) => {
    const [shouldShowPopupOnClick, setShouldShowPopupOnClick] = useState(true);
    const styles = useStyles();
    const hasConflicts = overrides.some(({ conflict }) => conflict);
    const hasOverrideForSelectedRoute =
      selectedRoute &&
      !hasConflicts &&
      overrides.some(({ routeCode }) => routeCode === selectedRoute?.routeCode);

    const overrideCount = !hasOverrideForSelectedRoute
      ? overrides.length
      : overrides.filter(
          ({ routeCode }) => routeCode === selectedRoute.routeCode
        ).length;

    const isMultipleRoutesPresent = () =>
      !!overrides.some(({ routeCode }) => routeCode !== overrides[0].routeCode);

    let textContainerStyle, textStyle;
    if (hasOverrideForSelectedRoute) {
      textStyle = {
        color: selectedRoute.textColour,
      };
      textContainerStyle = {
        background: selectedRoute.colour,
      };
    } else if (isMultipleRoutesPresent() || selectedRoute) {
      textStyle = {
        color: "white",
      };
      textContainerStyle = {
        background: "black",
      };
    } else if (routes) {
      const overrideRoute = routes.find((route) => {
        return route.routeCode === overrides[0].routeCode;
      });
      const colour = overrideRoute?.colour;
      const textColour = overrideRoute?.textColour;
      textStyle = {
        color: textColour,
      };
      textContainerStyle = {
        background: colour,
      };
    }

    return (
      <>
        <View
          className={styles.markerContainer}
          onClick={() => {
            handleOverrideModalChange(shouldShowPopupOnClick, {
              coordinates,
              onClose: () => setShouldShowPopupOnClick(true),
            });
            setShouldShowPopupOnClick(!shouldShowPopupOnClick);
          }}
          role="button"
          aria-pressed={shouldShowPopupOnClick}
        >
          <View>
            {(overrideCount > 1 || hasOverrideForSelectedRoute) && (
              <Grid container className={styles.overrideCountContainer}>
                <Text className={styles.overrideCountText}>
                  {overrideCount}
                </Text>
              </Grid>
            )}
            <Grid container className={styles.container}>
              {!hasConflicts ? (
                <Grid
                  container
                  className={styles.textContainer}
                  style={{ ...textContainerStyle }}
                >
                  <Text className={styles.text} style={{ ...textStyle }}>
                    O
                  </Text>
                </Grid>
              ) : (
                <Grid container className={styles.conflictIconContainer}>
                  <WarningIcon className={styles.conflictIcon} />
                </Grid>
              )}
            </Grid>
            <View className={styles.arrowContainer}>
              <View className={styles.arrow} />
            </View>
          </View>
        </View>
      </>
    );
  }
);
